function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.41.294H.426C.196.294 0 .5 0 .74v7.119c0 .24.196.445.425.445h1.146c.196 0 .36.17.36.342l-.033 1.06L3.96 8.372c.065-.034.13-.068.196-.068h4.255a.45.45 0 00.458-.445V.739a.45.45 0 00-.458-.445z",
  fill: "#00B8FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.296 4.583H4.923v1.24a.417.417 0 11-.833 0v-1.24H2.717a.417.417 0 110-.833h1.372V2.51a.417.417 0 01.834 0v1.24h1.373a.417.417 0 010 .833z",
  fill: "#FFF"
}));

function SvgPropuestaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropuestaIcon);
export default __webpack_public_path__ + "static/media/propuesta-icon.d22b488e.svg";
export { ForwardRef as ReactComponent };